import BirthdayPackagesPage from "./BirthdayPackagesPage";

export default BirthdayPackagesPage;